// extracted by mini-css-extract-plugin
export default {"container":"Header_container__qMawk","scrolled":"Header_scrolled__8bAWD","navLinks":"Header_navLinks__KRNYo","link":"Header_link__h-VMx","orderBtn":"Header_orderBtn__SE4ZJ"};